import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { TreasuryKRISummaryProvider } from "../../../context/TreasuryKRISummaryContext";
import WhatWeDo from "../../whatWeDo/WhatWeDo.component";
import useStyles from "./KRISummarySubmissionGlobal.styles";
import KRISummarySubmissionGlobalFiltersAndReports from "./KRISummarySubmissionGlobalFiltersAndReports.component";
import { ApprovalProvider } from "../../../context/ApprovalContext";
import { EmailProvider } from "../../../context/EmailContext";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const KRISummarySubmissionGlobal = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.page}>
      <Grid container spacing={2}>
        <TreasuryKRISummaryProvider>
          <ApprovalProvider>
            <EmailProvider>
              <KRISummarySubmissionGlobalFiltersAndReports />
            </EmailProvider>
          </ApprovalProvider>
        </TreasuryKRISummaryProvider>
        <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ display: "none" }}>
          <Item>
            <WhatWeDo />
          </Item>
        </Grid>
      </Grid>
    </div>
  );
};

export default KRISummarySubmissionGlobal;
